<template>
    <div>
        <div class="dataTitle">
            <div class="title">{{title}}</div>
            <div style="display: flex;justify-content: center;align-items: center;">
                <InputField label="" type="text" label-width="0%" id="partitionName" style="margin-right: 1rem;"
                            :modelValue="preForm.partitionName" placeholder="请输入区域名称"
                            @update:modelValue="(value) => handleModelPreValueUpdate('partitionName', value)"/>
                <a-space>
                    <ButtonField style="width: 80px;" text="查询" secondary @click="getSewagePageList"/>
                    <ButtonField style="width: 80px;" text="新增" @click="add" primary />
                </a-space>
            </div>
        </div>
        <Tablelist
            :showCheckbox="false"
            :list="list"
            :columns="tableColumns"
            :totalSize="preForm.totalSize"
            :totalPages="preForm.totalPages"
            :pageNum="preForm.pageNum"
            :pageSize="preForm.pageSize"
            @page-change="onChange"
        >
            <template v-slot:actions="{ item }">
                <a-space>
                    <a href="#" @click.prevent="editText(item)">编辑</a>
                    <a href="#" class="danger" @click.prevent="deleteText(item)">删除</a>
                </a-space>
            </template>
        </Tablelist>

        <Modal v-if="visible" v-model="visible"
               :visible="visible"
               :title="editShow?'编辑污水产生量':'新增污水产生量'"
               :showFooter="false"
               :overlayOpacity="0.5"
               :contentWidth="'50%'"
               @update:visible="visible = $event">
            <form>
                <div class="formDiv">
                    <div>
                        <InputField label="区域名称" type="text"  id="areaName"
                            :modelValue="form.areaName" placeholder="请输入区域名称"  required
                            @update:modelValue="(value) => handleModelValueUpdate('areaName', value)"/>
                    </div>
                    <div>
                        <InputField label="区域编码" type="text"  id="areaCode"
                                    :modelValue="form.areaCode" placeholder="请输入区域编码"  required
                                    @update:modelValue="(value) => handleModelValueUpdate('areaCode', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="月均自来水用量" type="Number"  id="tapWater"
                                    :modelValue="form.tapWater" placeholder="请输入月均自来水用量"
                                    @update:modelValue="(value) => handleModelValueUpdate('tapWater', value)"/>
                    </div>
                    <div>
                        <InputField label="常住人口数" type="Number"  id="population"
                                    :modelValue="form.population" placeholder="请输入常住人口数"
                                    @update:modelValue="(value) => handleModelValueUpdate('population', value)"/>
                    </div>
                </div>
                <div class="formDiv">
                    <div>
                        <InputField label="日均污水产生量" type="Number"  id="sewageNum"
                                    :modelValue="form.sewageNum" placeholder="请输入日均污水产生量"
                                    @update:modelValue="(value) => handleModelValueUpdate('sewageNum', value)"/>
                    </div>
                    <div>
                        <DatePickerField id="taskTime" labelWidth="40%" label="统计时间"
                                         :rules="[{ required: true, message: '请选择统计时间' }]"
                                         v-model="form.daytime"  name="daytime" placeholder="请选择统计时间"
                                         @update:modelValue="(value) => handleModelValueUpdate('daytime', value)"/>
                    </div>
                </div>

                <div style="display: flex;justify-content: center;">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" v-if="!saveShow" primary @click="handleSubmit"/>
                        <ButtonField text="下一步" v-else primary @click="handleNextStep"/>
                    </a-space>
                </div>
            </form>
        </Modal>
    </div>
</template>

<script>
import {
    fetchSewagePageList,
    saveSewagePage,
    modifySewagePage,
    remove,
} from "../api/diagnose";
export default {
    name: "index",
    props:{
        title: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            form:{
                areaName:null,areaCode:null,tapWater:null,population:null,sewageNum:null,daytime:null
            },
            visible:false,
            editShow:false,
            saveShow:false,
            list:[],
            tableColumns:[
                {key: 'areaName',title: '区域名称',field: 'areaName',width: '100px'},
                {key: 'areaCode',title: '区域编码',field: 'areaCode',width: '100px'},
                {key: 'tapWater',title: '月均自来水用量（立方米）',field: 'tapWater',width: '100px'},
                {key: 'population',title: '常住人口数（人）',field: 'population',width: '100px'},
                {key: 'sewageNum',title: '日均污水产生量（立方米/日）',field: 'sewageNum',width: '120px'},
                {key: 'daytime',title: '统计时间',field: 'daytime',width: '100px'},
                {key: 'actions',title: '操作',field: 'actions', infotype: 'template',width: '100px'},
            ],
            preForm:{
                totalSize: 1,
                totalPages: 1,
                pageNum: 1,
                pageSize: 10,
            }
        }
    },
    mounted() {
        this.getSewagePageList();
    },
    methods: {
        formatDate(dateString){
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        },
        onChange(pagination) {
            this.preForm.pageNum  = pagination;
            this.preForm.pageSize = 10;
            this.getSewagePageList();
        },
        handleModelPreValueUpdate(fieldName, value){
            this.preForm[fieldName] = value;
        },
        getSewagePageList(){
            fetchSewagePageList(this.preForm).then(res => {
                this.list = res.list.map(item => ({
                    ...item,
                    daytime: this.formatDate(item.daytime)
                }));
                this.preForm.totalPages = res.totalPages;
                this.preForm.totalSize = res.totalSize;
            })
        },
        handleModelValueUpdate(fieldName, value) {
            this.form[fieldName] = value;
        },
        add(){
            this.visible = true;
            this.editShow = false;
            this.saveShow = false;
            this.form = {}
        },
        editText(item){
            console.log("item:::",item)
            this.visible = true;
            this.editShow = true;
            this.saveShow = false;
            this.form = item;
        },
        deleteText(item){
            console.log("item:::",item)
            remove({
                id: item.id,
                type: "diagnose_sewage"
            }).then((res) => {
                console.log("res:", res);
                this.getSewagePageList();
            }).catch((error) => {
                console.error("删除失败:", error);
            });
        },
        cancel() {
            this.visible = false;
        },
        handleSubmit(){
            this.form.daytime = new Date();
            if(this.form.id){
                modifySewagePage(this.form).then(res => {
                    console.log("modifySewagePage   res:::",res)
                    this.getSewagePageList()
                })
            }else{
                saveSewagePage(this.form).then(res => {
                    console.log("saveSewagePage   res:::",res)
                    this.getSewagePageList()
                })
            }
            this.saveShow = true
        },
        handleNextStep(){
            this.visible = false;
            this.$bus.$emit('switch-component', 'watLvlCtrl');
        }
    }
}
</script>

<style scoped>
.dataTitle{
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin:0 0 1rem 0;
}
.title{
    font-size: 1.2rem;
    color: #00ff96;
    font-weight: bold;
}
.formDiv{
    display: flex;
    justify-content: space-between;
    margin: 1rem 0;
}
.formDiv > div{
    width: 48%;
}
</style>